import { DashboardGeracao } from "./DashboardGeracao";

export default DashboardGeracao;